import { searchService, transactionService, mainService, baseUrlService, homeService } from '@/utils/request'

// 搜索页、搜索接口
export function storeShareSearch (data) {
  return searchService({
    url: 'api/store/share/search',
    method: 'post',
    data: data
  })
}

// 获取图片分类列表
export function resourceCategorys () {
  return searchService({
    url: 'api/share/resource/category',
    method: 'post',
    data: {}
  })
}

// 获取图片分类列表（新）
// export function resourceClassNameList () {
//   return searchService({
//     url: 'api/common/aggs_cate?endpoint=GTY_STORE',
//     method: 'get'
//   })
// }

// 获取图片分类列表（最新）
export function resourceClassNameList () {
  return homeService({
    url: 'web/get_keyword_class',
    method: 'get',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取作品关联书刊
export function getWorksLinkBook (data) {
  return searchService({
    url: 'api/store/share/list_r_books',
    method: 'post',
    data: data
  })
}

// 获取作品详情
export function getWorksDetail (id) {
  return transactionService({
    url: 'works/detail',
    method: 'get',
    params: {
      originId: id
    }
  })
}

// 获取相似图片
export function getSimilarImages (data) {
  return mainService({
    url: 'app/picture_group/picIdSimilarPicture',
    method: 'post',
    data: data
  })
}

// 获取共享库作品详情接口
export function getShareResourceDetail (data) {
  return searchService({
    url: 'api/share/resource/detail',
    method: 'post',
    data: data
  })
}

// 查看店铺详情
// accountId = ownerType + "-" + ownerId
export function getAccountDetail (accountId) {
  return transactionService({
    url: `account/getById?accountId=${accountId}`,
    method: 'get'
  })
}

// 以图搜图
export function getSimilarImagesByImg (data) {
  return baseUrlService({
    url: 'file/gtyresource-sale-share/api/store/share/similar/byImg',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

// 以图搜图（分页）
// pageNo、picPath、endpoint
export function getSimilarImagesByImgPages (data) {
  return baseUrlService({
    url: 'gtyresource-sale-share/api/store/share/similar/byImg/page',
    method: 'get',
    params: data
  })
}
